import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12h2a2 2 0 1 0 0 -4h-2v8","key":"svg-0"}],["path",{"d":"M17 8h4","key":"svg-1"}],["path",{"d":"M19 8v8","key":"svg-2"}],["path",{"d":"M10 8v6a2 2 0 1 0 4 0v-6","key":"svg-3"}]]

const IconHttpPut = createReactComponent('outline', 'http-put', 'HttpPut', __iconNode);

export default IconHttpPut;